import { Contato } from '../../types';
import { getPreset } from './presets';
import * as S from './styles';

interface Props {
  contato: Contato;
  onSelect: (contato: Contato) => void;
}

function ServiceCard({ contato, onSelect }: Props) {
  const preset = getPreset(contato.tipoContatoId);
  const { Icon, ButtonIcon } = preset;

  return (
    <S.Card>
      <S.CardIcon $gradient={preset.iconBgGradient}>
        <Icon size={40} color={preset.iconColor} />
      </S.CardIcon>

      <S.CardLabel>{preset.label}</S.CardLabel>
      <S.CardTitle>{contato.descricao}</S.CardTitle>
      <S.CardText>{preset.descricao}</S.CardText>

      <S.CardFooter>
        <S.CardButton
          type="button"
          onClick={() => onSelect(contato)}
          $bg={preset.buttonBg}
          $color={preset.buttonTextColor}
          $hoverBg={preset.buttonHoverBg}
          $hoverColor={preset.buttonHoverTextColor}
        >
          {preset.buttonIconPosition === 'left' && <ButtonIcon size={20} />}
          {preset.buttonText}
          {preset.buttonIconPosition === 'right' && <ButtonIcon size={20} />}
        </S.CardButton>
      </S.CardFooter>
    </S.Card>
  );
}

export default ServiceCard;
